import './jquery-confirm';
import {OoredooIcon} from "./OoredooIcon";
import {errorAlert, fixAlertContentHeight, successAlert} from "./jquery-confirm";

export const LoadRecaptchaScript = () => {
    return new Promise((resolve, reject) => {
        if (typeof window.grecaptcha !== 'undefined') {
            return resolve(window.grecaptcha);
        }

        const sc = document.createElement('script');
        sc.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=explicit&hl=ar');
        sc.setAttribute('async', 'async');
        sc.setAttribute('defer', 'defer');

        sc.onload = function () {
            window.grecaptcha.ready(function () {
                setTimeout(function () {
                    resolve(window.grecaptcha);
                }, 300);
            });
        }

        sc.onerror = function (event) {
            console.error('LoadingRecaptchaFailed', event);
            reject(event);
        }
        document.getElementsByTagName('head')[0].appendChild(sc);
    });
}
export const RenderRecaptcha = (target, callback, level = 0) => {

    return new Promise((resolve, reject) => {
        LoadRecaptchaScript()
            .then(() => {
                const data = {
                    sitekey: application.oss.recaptcha.sitekey,
                    hl: $('html').attr('lang')
                };
                if (typeof callback === 'function') {
                    data['callback'] = callback;
                }

                resolve(window.grecaptcha.render(target, data));
            });
    });
}

export const ShowRecaptchaPopup = (xhr, popupOptions) => {

    if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.required_recaptcha !== 'undefined' && xhr.responseJSON.required_recaptcha === true) {
        let recaptchaWidgetId = '';
        let message = application.oss.translations.oss_form.recaptcha_challenge_message;

        if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.message !== 'undefined' && xhr.responseJSON.message && xhr.responseJSON.message.toString().length) {
            message = `<p>${xhr.responseJSON.message}</p><p>${message}</p>`;
        }

        let bootstrapClasses = {
            container: 'container',
            containerFluid: 'container-fluid',
            row: 'row'
        };

        if (typeof popupOptions !== 'undefined' && typeof popupOptions.bootstrapClasses !== 'undefined') {
            bootstrapClasses = popupOptions.bootstrapClasses;
        }

        errorAlert(`<div class="confirm-content">
                          <div id="confirm-message" class="confirm-div">${message}</div>
                          <div class="recaptcha-challenge-box"><div id="recaptcha-challenge" class="confirm-div"></div></div>
</div>`,{
            title: '',
            iconHtml: OoredooIcon('icon-cancel1'),
            bootstrapClasses: bootstrapClasses,
            onContentReady: function () {
                var jc = this;
                jc.buttons.confirm.disable();
                RenderRecaptcha(jc.$content.find('#recaptcha-challenge')[0], function (response) {
                    jc.buttons.confirm.enable();
                }).then((resolvedId) => {
                    recaptchaWidgetId = resolvedId;
                    fixAlertContentHeight(jc);
                });

            },
            buttons: {
                confirm: {
                    text: application.oss.translations.oss_form.confirm_recaptcha_challenge,
                    btnClass: 'main-btn',
                    action: function () {
                        var jc = this;
                        const recaptchaValue = window.grecaptcha.getResponse(recaptchaWidgetId);

                        $.ajax({
                            url: application.oss.urls.resolve_recaptcha,
                            dataType: 'json',
                            method: 'post',
                            bootstrapClasses: bootstrapClasses,
                            data: {
                                code: recaptchaValue,
                            },
                            xhrFields: {
                                withCredentials: true
                            },
                            beforeSend: function () {
                                jc.showLoading();
                            },
                            success: (response) => {
                                if (typeof response.status !== 'undefined' && response.status) {
                                    jc.close();
                                    successAlert('',{
                                        title: '',
                                        bootstrapClasses: bootstrapClasses,
                                        content: `
                                              <div class="confirm-content"><div class="confirm-div">${application.oss.translations.oss_form.confirm_recaptcha_challenge_passed_message}</div>
                                              `,
                                        buttons: {
                                            close: {
                                                text: application.oss.translations.oss_form.close,
                                                btnClass: 'main-btn',
                                            },
                                        }
                                    });
                                }
                                jc.hideLoading();
                                jc.buttons.confirm.disable();

                            },
                            complete: function () {
                                window.grecaptcha.reset(recaptchaWidgetId);
                                jc.buttons.confirm.disable();
                                jc.hideLoading();
                            },
                            error: (xhr) => {
                                jc.hideLoading();
                                jc.buttons.confirm.disable();
                                jc.$content.find('#confirm-message').html(application.oss.translations.oss_form.confirm_recaptcha_challenge_failed_message);
                                window.grecaptcha.reset(recaptchaWidgetId);
                            }

                        })


                        return false;

                    }
                }
            }
        });

        return true;
    }

    return false;
}
